"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _actionMenuTypes = _interopRequireDefault(require("../../../common/app-action-menu/action-menu-types"));

var _default = _propTypes.default.oneOf([_actionMenuTypes.default.EDIT, _actionMenuTypes.default.DUPLICATE, _actionMenuTypes.default.DELETE]);

exports.default = _default;